module.exports = __webpack_public_path__ + "static/bg-dac50fe846e667cefffed66a073f1134.jpg";